import { EventTrackerService, UserActionType, Page } from '../../../services/event-tracker/event-tracker.service';
import { UserService } from '../../../services/user.service';
import { UserDetails } from '../../../../models/user';
import { UserDetailsComponent } from './user-details/user-details.component';
import { ChangePwdComponent } from './change-pwd/change-pwd.component';
import { NotificationSettingComponent } from './notification-setting/notification-setting.component';
import { ModalService } from '../../../services/modal/modal.service';
var UserSettingsComponent = /** @class */ (function () {
    function UserSettingsComponent(eventTracker, userService, modalService) {
        this.eventTracker = eventTracker;
        this.userService = userService;
        this.modalService = modalService;
        this.currentUserDetails = new UserDetails();
        this.isUserDetailsChanged = false;
        this.hasUpdatedPwd = false;
    }
    UserSettingsComponent.prototype.ngOnInit = function () {
        this.sendViewSettingsEvent();
        this.getCurrentUserInfo();
        this.getNotificationSetting();
    };
    UserSettingsComponent.prototype.getCurrentUserInfo = function () {
        var _this = this;
        this.userService.getCurrentUserInfo().subscribe(function (res) {
            if (res && res.data) {
                _this.currentUserDetails = res.data;
            }
        });
    };
    UserSettingsComponent.prototype.afterUpdatePasswordCallback = function (evt) {
        this.hasUpdatedPwd = evt;
        if (evt) {
            this.userDetailsComponent.uploadProfilePicture(this.userDetailsComponent.selectedImage);
        }
    };
    UserSettingsComponent.prototype.saveUserData = function () {
        this.modalService.close();
        if (this.changePwdComponent.hasFormChanged() && !this.userDetailsComponent.userDetails.dirty && !this.userDetailsComponent.hasChangedImage) {
            this.isUserDetailsChanged = false;
            this.changePwdComponent.onSubmit();
        }
        if (this.changePwdComponent.hasFormChanged() && (this.userDetailsComponent.userDetails.dirty || this.userDetailsComponent.hasChangedImage)) {
            this.isUserDetailsChanged = true;
            this.changePwdComponent.onSubmit();
        }
        if (this.userDetailsComponent.hasChangedImage && this.changePwdComponent.hasFormEmpty()) {
            this.userDetailsComponent.uploadProfilePicture(this.userDetailsComponent.selectedImage);
        }
        if (this.userDetailsComponent.userDetails.dirty && !this.userDetailsComponent.hasChangedImage && this.changePwdComponent.hasFormEmpty()) {
            this.userDetailsComponent.onSubmitUserDetails();
        }
        if (this.notificationSettingComponent.hasChangedNotificationSettings()) {
            this.notificationSettingComponent.saveNotificationSetting();
        }
    };
    UserSettingsComponent.prototype.getNotificationSetting = function () {
        var _this = this;
        this.userService.loadNotificationSetting().subscribe(function (res) {
            if (res) {
                _this.notificationSetting = res;
            }
        });
    };
    UserSettingsComponent.prototype.sendViewSettingsEvent = function () {
        this.eventTracker.trackUserAction(UserActionType.VIEW, Page.SETTINGS_PAGE, undefined, undefined, undefined, null, null);
    };
    Object.defineProperty(UserSettingsComponent.prototype, "isDisableSaveBtn", {
        get: function () {
            return (this.userDetailsComponent.userDetails.invalid && (this.userDetailsComponent.userDetails.touched || this.userDetailsComponent.userDetails.dirty))
                || (!this.changePwdComponent.isValidNewPwd);
        },
        enumerable: true,
        configurable: true
    });
    return UserSettingsComponent;
}());
export { UserSettingsComponent };



// WEBPACK FOOTER //
// ./src/app/main/account-setting/user-settings/user-settings.component.ts.pre-build-optimizer.js